import { useState } from 'react';
import { useExpressCheckoutButtonsData } from '../../provider/useExpressCheckoutButtonsData';
import { ExpressCheckoutModalType } from './ExpressCheckoutErrorModal.utils';
const getModalType = _ref => {
  let {
    isShippable,
    canBusinessShip,
    isPremium,
    isOwner,
    viewMode
  } = _ref;
  if (!isPremium) {
    return isOwner ? ExpressCheckoutModalType.OwnerNoPremium : ExpressCheckoutModalType.BuyerNoPremium;
  }
  if (isShippable && !canBusinessShip) {
    return isOwner ? ExpressCheckoutModalType.OwnerNoShipping : ExpressCheckoutModalType.BuyerNoShipping;
  }
  if (viewMode === 'Preview') {
    return ExpressCheckoutModalType.PreviewMode;
  }
  return undefined;
};
export const useCheckoutErrorModal = _ref2 => {
  let {
    isShippable
  } = _ref2;
  const data = useExpressCheckoutButtonsData();
  const {
    isDisplayErrorModalsEnabled,
    canBusinessShip,
    isPremium,
    isOwner,
    viewMode
  } = data ?? {};
  const [isCheckoutErrorModalOpen, setIsCheckoutErrorModalOpen] = useState(false);
  const modalType = isDisplayErrorModalsEnabled ? getModalType({
    isShippable,
    canBusinessShip,
    isPremium,
    isOwner,
    viewMode
  }) : undefined;
  return {
    modalType,
    isCheckoutErrorModalOpen,
    openCheckoutErrorModal: () => setIsCheckoutErrorModalOpen(true),
    closeCheckoutErrorModal: () => {
      setIsCheckoutErrorModalOpen(false);
      data == null || data.onCancel == null || data.onCancel();
    }
  };
};
//# sourceMappingURL=useCheckoutErrorModal.js.map